import { useState } from 'react';

export const useSettingEdit = <T>() => {
  const [editTarget, setEditTarget] = useState<T | null>(null);

  const openEditMode = (target: T) => {
    setEditTarget(target);
  };

  const closeEditMode = () => {
    setEditTarget(null);
  };

  const register = (name: T) => ({
    isEditMode: editTarget === name,
    showEditButton: editTarget === name || editTarget === null,
    onClick: () => openEditMode(name),
    onClose: closeEditMode,
  });

  return { editTarget, register };
};
